export const chartColors = {
  InTEM: '#F7996A',
  RHIME: '#1D70B8',
  Inventory: '#0F385C',
  Mean: '#7F65B7',
} as const;
